// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5481":"css/admin-app.6917","9226":"css/app.6917"}[chunkId] + ".css";
};